import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Tabs } from 'antd';

import InvoiceSummaryUI from './InvoiceSummaryUI';

import { pageSectionTitle } from '../util/Style';
import InvoiceSummaryStore from '../stores/InvoiceSummaryStore';

const { TabPane } = Tabs;

const tabBarStyle = {
    fontWeight: "bold",
}

class InvoiceUI extends Component {

    constructor(props) {
        super(props);

        this.dailyStore = new InvoiceSummaryStore({ apiProxy: props.appStore.apiProxy, collectionType: "daily" });
        this.monthlyStore = new InvoiceSummaryStore({ apiProxy: props.appStore.apiProxy, collectionType: "monthly" });
    }

    render() {
        return (
            <Tabs style={{paddingLeft:10,paddingRight:10}} defaultActiveKey="1" tabBarStyle={tabBarStyle} tabBarExtraContent={pageSectionTitle("Invoices")}>
                <TabPane tab="Daily" key="1">
                    <InvoiceSummaryUI appStore={this.props.appStore} title="Daily" store={this.dailyStore} />
                </TabPane>
                <TabPane tab="Monthly" key="2">
                    <InvoiceSummaryUI appStore={this.props.appStore} title="Monthly" store={this.monthlyStore} />
                </TabPane>
            </Tabs>
        )
    }
}

export default observer(InvoiceUI)
